/* This file is autogenerated, see readme.md for instructions */
import LineChartSvgIcon from '@bloomreach/banana-theme/icons/line-chart.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const LineChartIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <LineChartSvgIcon />
    </Icon>
  );
});

LineChartIcon.displayName = 'LineChartIcon';

export default LineChartIcon;
